.place-button{
    display: inline-block !important;
    margin: 20px;
}